import { Dictionary_URL } from '@/helpers/URL'

const DictionaryControllerEndpoint = path => {
  if (!path) {
    throw new Error('Path is required')
  }
  return `${Dictionary_URL}${path}`
}

// POST Endpoints
export const UPDATE_DICTIONARY_DETAILS = DictionaryControllerEndpoint('updateDictionaryDetails')
export const UPDATE_DICTIONARY_DETAIL = DictionaryControllerEndpoint('updateDictionaryDetail')
export const GET_MULTIPLE_DICTIONARY_DETAILS = DictionaryControllerEndpoint(
  'getMultipleDictionaryDetails'
)
export const GET_MULTIPLE_DICTIONARIES = DictionaryControllerEndpoint('getMultipleDictionaries')
export const GET_DICTIONARY_MASTER_FOR_CODE = DictionaryControllerEndpoint(
  'getDictionaryMasterForCode'
)
export const GET_DICTIONARY_DETAILS = DictionaryControllerEndpoint('getDictionaryDetails')
export const DELETE_DICTIONARY_DETAIL = DictionaryControllerEndpoint('deleteDictionaryDetail')
export const ADD_DICTIONARY_DETAIL = DictionaryControllerEndpoint('addDictionaryDetail')

// GET Endpoints
export const GET_ALL_DICTIONARY = DictionaryControllerEndpoint('getAllDictionary')
export const GET_ALL_DICTIONARY_DETAILS = DictionaryControllerEndpoint('getAllDictionaryDetails')
